<template>
    <div>
        <v-row no-gutters justify="center" class="title_bar">
            <v-col cols="11" md="10" lg="6"><h1 class="pa-1">ISO 9001 Minősítés</h1></v-col>
        </v-row>
        <v-row no-gutters justify="center" class="mt-5">
            <v-col cols="11" md="10" lg="6">
                <h2 class="subtitle">Általános követelmények</h2>
                <v-img id="image" width="130px" class="ml-2 mt-2" src="@/assets/images/iso.jpg"></v-img>
                <p id="image_text">A BNS Mérnökiroda Kft az ISO 9001:2008 szabvány követelményei szerint alakította ki minőségirányítási rendszerét. A kft minőségirányítási
                rendszere a modell szabvány 7.5.2-es szabványpont szerinti szabályozást nem használja (nem alkalmazható), továbbá kizárásra kerültek a
                könyvelői folyamatok is, ennek megfelelően a társaság által végzett tevékenységek között nincs olyan folyamat, amelynek kimenete nem
                mérhető. A minőségirányítási rendszer hatálya a BNS Mérnökiroda Kft-nél, az „irányítástechnika és villamos-energiaellátás ipari
                létesítmények) tervezése, kivitelezése" folyamatokra terjed ki, illetve az ezeket
                kiegészítő, támogató tevékenységekre, biztosítva azok folyamatos felügyeletét,
                működését és javítását.</p>
                <h2 class="subtitle">A Minőségirányítási rendszerünkben kötelezően szabályozott folyamatok:</h2>
                <v-row
                    v-for="i in lists"
                    :key="i"
                    :title="i"
                    class="my-2 ml-0"
                >
                    <v-icon style="color:#920825">mdi-chevron-right</v-icon><p class="ma-0">{{i}}</p>
                </v-row>
                <h2 class="subtitle">A Minőségirányítási rendszerünket támogató, szabályozott tevékenységek:</h2>
                <v-row
                    v-for="i in lists2"
                    :key="i"
                    :title="i"
                    class="my-2 ml-0"
                >
                    <p class="ma-0"><v-icon style="color:#920825">mdi-chevron-right</v-icon>{{i}}</p>
                    
                </v-row>
                <p>A rendszer alapját képező dokumentumok és a hozzájuk
                rendelhető bizonylatok, formalapok egyértelműen
                szabályozzák a különböző tevékenységek folyamatát, a
                kapcsolódási pontokat, valamint a folyamatokban résztvevők
                felelősségét. A minőségirányítási rendszer működtetése a
                társaság által megfogalmazott, leírt és bevezetett kézikönyv
                (dokumentum) alapján történik. Ez a rendszer biztosítja,
                hogy a tevékenységünk során a minőségre kiható minden
                folyamatot, feladatot ellenőrzött és szabályozott
                körülmények között végezzünk.</p>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name:'Iso',
    data(){
        return{
            lists:[
                "Dokumentumok kezelése",
                "Bizonylatok kezelése",
                "Nem megfelelőségek kezelése",
                "Belső minőségirányítási auditok",
                "Helyesbítő tevékenység",
                "Megelőző tevékenység"
            ],
            lists2:[
                "Megbízások fogadása, szerződéskötés",
                "Vezetőségi átvizsgálások",
                "Erőforrások biztosítása, képzés",
                "Beszerzés",
                "Tervezés, kivitelezői folyamatok",
                "Mérés, elemzés, fejlesztés, statisztika"
            ]
        }
    }
}
</script>
<style scoped>
    .title_bar{
        background-color: #920825;
        color: white;
    }
    .subtitle{
        color: #920825;
    }
    p {
            text-align: justify;
        }
    #image {
            float: right;
        }
</style>